import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json"
    },
    supportedLngs: [
      "en",
      "pl",
      "de",
      "bn",
      "bg",
      "es",
      "fr",
      "it",
      "nl",
      "pt",
      "ru",
      "el",
      "gu",
      "lv",
      "lt",
      "pa",
      "ro",
      "uk",
      "cy",
      "hu",
      "zh",
      "tr",
      "th",
      "ne",
      "da",
      "vi"
    ],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"]
    }
  });

export default i18n;
